<div class="aa-modal">
    <div class="modal-head">
        <div class="title-block">
            <h2>
                <i class="bi bi-clipboard2-check"></i>
                Awaiting Approvals
                <span class="count">{{ allAwaitingApprovals?.length || 0 }}</span>
            </h2>
            <div class="sub">Timesheets pending review.</div>
        </div>
        <button type="button" class="close-btn" (click)="close()" title="Close">
            <i class="bi bi-x-lg"></i>
        </button>
    </div>

    <div class="modal-body">
        <div class="aa-table-wrap" *ngIf="allAwaitingApprovals?.length; else aaEmpty">
            <table class="aa-table">
                <thead>
                    <tr>
                        <th>Contractor</th>
                        <th>Job</th>
                        <th>Client</th>
                        <th>Period</th>
                        <th class="num-col">Hours</th>
                        <th class="actions-col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let awaitingApproval of allAwaitingApprovals; let i = index">
                        <td>
                            <div class="cell-contractor">
                                <div class="avatar">
                                    <img *ngIf="awaitingApproval.profile_pic"
                                        [src]="dataSharedService.getImage(awaitingApproval.profile_pic)"
                                        [alt]="awaitingApproval.candidate" />
                                    <span *ngIf="!awaitingApproval.profile_pic">
                                        {{ authService.getInitials(awaitingApproval.candidate) }}
                                    </span>
                                </div>
                                <span class="name">{{ awaitingApproval.candidate }}</span>
                            </div>
                        </td>
                        <td>{{ awaitingApproval.job }}</td>
                        <td>{{ awaitingApproval.client }}</td>
                        <td class="period-col">
                            {{ dataSharedService.tranformDate(awaitingApproval.start_date) }} –
                            {{ dataSharedService.tranformDate(awaitingApproval.end_date) }}
                        </td>
                        <td class="num-col">{{ awaitingApproval.total_hours }}</td>
                        <td class="actions-col">
                            <div class="row-actions">
                                <!-- <button type="button" class="icon-btn-sm"
                  title="View timesheet"
                  (click)="openTimesheetDetails(awaitingApproval, awaitingApproval.status, true)">
                  <i class="bi bi-eye"></i>
                </button> -->
                                <button type="button" class="icon-btn-sm" title="Send reminder"
                                    (click)="openSendReminderPopUp(awaitingApproval.client_uuid, awaitingApproval.candidate, awaitingApproval.job)">
                                    <i class="bi bi-envelope"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-template #aaEmpty>
            <div class="aa-empty">
                <div class="ico"><i class="bi bi-check2-circle"></i></div>
                <h4>Nothing awaiting</h4>
                <p>You're all caught up on approvals.</p>
            </div>
        </ng-template>
    </div>
</div>